import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {},
	list: {
		margin: 0,
		padding: 0,
		listStyle: "none",
	},
	item: {
		padding: "0 0 0 14px",
		marginBottom: "7px",
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		lineHeight: 1.42,
		position: "relative",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	icon: {
		position: "absolute",
		left: 0,
		fontSize: "15px",
		color: theme.palette.colors.darkSlateBlue,
	},
	value: {
		paddingLeft: "10px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		item: {
			marginBottom: "4px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		item: {
			marginBottom: "4px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
}));

const BenefitsList = ({ items }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ul className={classes.list}>
				{items.map((item, index) => {
					return (
						<li className={classes.item} key={index}>
							<span className={classNames(["icon24", item.icon, classes.icon])} />
							<span className={classes.value}>{item.name}</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default BenefitsList;
